// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Session Loader - From Uiverse.io by terenceodonoghue */
.session-loader-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-primary, #ffffff);
  z-index: 9999;
}

.session-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 50%;
  height: 96px;
  width: 96px;
  animation: rotate_3922 1.2s linear infinite;
  background-color: #9b59b6;
  background-image: linear-gradient(#9b59b6, #84cdfa, #5ad1cd);
}

.session-loader span {
  position: absolute;
  border-radius: 50%;
  height: 100%;
  width: 100%;
  background-color: #9b59b6;
  background-image: linear-gradient(#9b59b6, #84cdfa, #5ad1cd);
}

.session-loader span:nth-of-type(1) {
  filter: blur(5px);
}

.session-loader span:nth-of-type(2) {
  filter: blur(10px);
}

.session-loader span:nth-of-type(3) {
  filter: blur(25px);
}

.session-loader span:nth-of-type(4) {
  filter: blur(50px);
}

.session-loader::after {
  content: "";
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  background-color: #fff;
  border: solid 5px #ffffff;
  border-radius: 50%;
}

@keyframes rotate_3922 {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

/* Dark mode support */
[data-theme='dark'] .session-loader-container {
  background-color: var(--bg-primary, #1a1a1a);
}

[data-theme='dark'] .session-loader::after {
  background-color: var(--bg-primary, #1a1a1a);
  border-color: var(--bg-primary, #1a1a1a);
}

`, "",{"version":3,"sources":["webpack://./src/components/SessionLoader.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,2CAA2C;EAC3C,yBAAyB;EACzB,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,4DAA4D;AAC9D;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE;IACE,6CAA6C;EAC/C;;EAEA;IACE,+CAA+C;EACjD;AACF;;AAEA,sBAAsB;AACtB;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C","sourcesContent":["/* Session Loader - From Uiverse.io by terenceodonoghue */\n.session-loader-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--bg-primary, #ffffff);\n  z-index: 9999;\n}\n\n.session-loader {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  border-radius: 50%;\n  height: 96px;\n  width: 96px;\n  animation: rotate_3922 1.2s linear infinite;\n  background-color: #9b59b6;\n  background-image: linear-gradient(#9b59b6, #84cdfa, #5ad1cd);\n}\n\n.session-loader span {\n  position: absolute;\n  border-radius: 50%;\n  height: 100%;\n  width: 100%;\n  background-color: #9b59b6;\n  background-image: linear-gradient(#9b59b6, #84cdfa, #5ad1cd);\n}\n\n.session-loader span:nth-of-type(1) {\n  filter: blur(5px);\n}\n\n.session-loader span:nth-of-type(2) {\n  filter: blur(10px);\n}\n\n.session-loader span:nth-of-type(3) {\n  filter: blur(25px);\n}\n\n.session-loader span:nth-of-type(4) {\n  filter: blur(50px);\n}\n\n.session-loader::after {\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  right: 10px;\n  bottom: 10px;\n  background-color: #fff;\n  border: solid 5px #ffffff;\n  border-radius: 50%;\n}\n\n@keyframes rotate_3922 {\n  from {\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n\n  to {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n\n/* Dark mode support */\n[data-theme='dark'] .session-loader-container {\n  background-color: var(--bg-primary, #1a1a1a);\n}\n\n[data-theme='dark'] .session-loader::after {\n  background-color: var(--bg-primary, #1a1a1a);\n  border-color: var(--bg-primary, #1a1a1a);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
